import { fetchAcceptancesList } from '@/fsd/pages/acceptances/api/fetchAcceptancesList/fetchAcceptancesList';
import { queryClient } from '@/fsd/shared/lib/react-query/queryClient';
import { getPurchaseItemLocation } from './getPurchaseItemLocation';
import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { NavigateFunction } from 'react-router-dom';
import { fetchShipmentList } from '@/fsd/pages/shipments/api/fetchShipmentList/fetchShipmentList';

interface IParams {
  navigate: NavigateFunction;
}

export const moveToShipmentItem = async ({ navigate }: IParams) => {

  const result = await queryClient.fetchQuery({
    queryKey: ['shipmentList'],
    queryFn: async () =>
      await fetchShipmentList({
        metaData: { current_page: 1, page_size: 1 },
      }),
  });

  const itemId = result?.data[0].id;


  const purchaseItemLocation = getPurchaseItemLocation(
    routes.shipmentItem.path,
    itemId
  );

  console.log(
    'moveToShipmentItem',
    'purchaseItemLocation',
    purchaseItemLocation
  );

  navigate(purchaseItemLocation);
};
